import React from "react";
import styles from "./progressBarOnboarding.module.css";
import { TStage } from "../../types/types";
import { tWithKeyAttr as t } from "../../i18nHelper";
import i18n from "../../i18n";

interface ProgressBarProps {
  steps: TStage[];
  currentStep: TStage; // 0-based
  onStepClick?: (index: number) => void;
}

const ProgressBarOnboarding: React.FC<ProgressBarProps> = ({
  steps,
  currentStep,
  onStepClick,
}) => {
  // Calculate progress based on completed steps only
  const completedSteps = Math.max(0, currentStep.stageNumber - 1);
  const pct =
    steps.length > 1
      ? Math.min(
          100,
          Math.max(0, (completedSteps / (steps.length - 1)) * 100)
        )
      : 0;

  return (
    <div
      className={styles.wrapper}
      role="group"
      aria-label="Onboarding progress"
      dir={i18n.dir()}
    >
          <div className={styles.track} aria-hidden="true">
          <div className={styles.trackFill} style={{ width: `${pct}%` }} />
        </div>
      
      <div className={styles.stepsRow}>
    
         {steps.map((label, i) => {
          const isCompleted = i < currentStep.stageNumber -1;
          const isCurrent = i === currentStep.stageNumber - 1;
          const circleClass = [
            styles.circle,
            isCompleted ? styles.completed : "",
            isCurrent ? styles.current : "",
          ]
            .join(" ")
            .trim();

          return (
            <div 
              key={i} 
              className={styles.stepItem}
            >
              <button
                type="button"
                className={circleClass}
                onClick={onStepClick ? () => onStepClick(i) : undefined}
                aria-current={isCurrent ? "step" : undefined}
                aria-label={t("PROGRESS_STEP_ARIA_LABEL", {
                  label: label.name,
                  stepNumber: i + 1,
                  totalSteps: steps.length,
                })}
              >
                {isCompleted ? (
                  <svg
                    className={styles.checkIcon}
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                    aria-hidden="true"
                  >
                    <path
                      d="M20 6L9 17l-5-5"
                      fill="none"
                      stroke="white"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                ) : (
                  <span className={styles.stepNumber}>{i + 1}</span>
                )}
              </button>

              <div className={styles.label} title={label.name}>
                {label.name}
              </div>
            </div>
          );
        })}
      </div>

      <div className={styles.summary}>
      {t("PROGRESS_STEP_SUMMARY", {
          currentStep: Math.min(currentStep.stageNumber, steps.length),
          totalSteps: steps.length,
        })}
      </div>
    </div>
  );
};

export default ProgressBarOnboarding;
